import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedisonRegistrationComponent } from '../medison-registration/medison-registration.component';
import { MedisonMedicalRoutingModule } from './medisonmedical-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MadisonverificationComponent } from '../madisonverification/madisonverification.component';
import { MadisonInsuranceComponent } from '../madison-insurance/madison-insurance.component';
import { MadisonThankyouComponent } from '../madison-thankyou/madison-thankyou.component';
import { MadisonPHIComponent } from '../madison-phi/madison-phi.component';
import { MadisonReferalComponent } from '../madison-referal/madison-referal.component';
import { MadisonInjuredComponent } from '../madison-injured/madison-injured.component';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'


@NgModule({
  declarations: [
    MedisonRegistrationComponent ,
    MadisonverificationComponent,
    MadisonInsuranceComponent,
    MadisonThankyouComponent,
    MadisonPHIComponent,
    MadisonReferalComponent,
    MadisonInjuredComponent
    
    

    
  ],
  imports: [
    CommonModule,
    MedisonMedicalRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ]
})
export class MedisonmedicalModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
